package com.myrestaurants.sharedmodels

import kotlinx.serialization.Serializable

/**
 * Created by User on 10/2/2017.
 */
@Serializable
data class PlaceFilter (
    var listId: String? = null,
    var name: String? = null,
    var ratingMin: Float = 0f,
    var ratingMax: Float = 5f,
    var priceRangeMin: Float = 0f,
    var priceRangeMax: Float = 5f,
    var deviceId: String? = null,
    var placeType: String? = null,
    var wish: Int = 0,
    var needReservation: Int = 0,
    var tags: String? = null
){
    val WISH_FALSE = 1
    val WISH_TRUE = 2
}
//{
//    var listId: String? = null
//
//    var name: String? = null
//    var ratingMin: Float = 0f
//    var ratingMax: Float = 5f
//    var priceRangeMin: Float = 0f
//    var priceRangeMax: Float = 5f
//    var deviceId: String? = null
//    var placeType: String? = null
//    var wish: Int = 0
//    var needReservation: Int = 0
////    var lastVisitDateMin: java.util.Date? = null
////    var lastVisitDateMax: java.util.Date? = null
//    var tags: List<String>? = null



//}
